var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout-btn",on:{"click":_vm.logout}},[_c('feather-icon',{staticStyle:{"color":"#fff"},attrs:{"icon":"PowerIcon","svgClasses":"w-4 h-4"}}),_c('p',{staticClass:"ml-2"},[_vm._v("خروج از حساب کاربری")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }